import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDiagnosisCodes,
  createDiagnosisCode,
  updateDiagnosisCode,
} from "../thunks/diagnosisCodesThunk";

const initialState = {
  diagnosisCodes: [],
  loading: false,
  error: null,
};

const diagnosisCodesSlice = createSlice({
  name: "diagnosisCodes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch diagnosis codes
      .addCase(fetchDiagnosisCodes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDiagnosisCodes.fulfilled, (state, action) => {
        state.loading = false;
        state.diagnosisCodes = action.payload;
      })
      .addCase(fetchDiagnosisCodes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create diagnosis code
      .addCase(createDiagnosisCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDiagnosisCode.fulfilled, (state, action) => {
        state.loading = false;
        state.diagnosisCodes.push(action.payload);
      })
      .addCase(createDiagnosisCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update diagnosis code
      .addCase(updateDiagnosisCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDiagnosisCode.fulfilled, (state, action) => {
        state.loading = false;
        state.diagnosisCodes = state.diagnosisCodes.map((code) =>
          code._id === action.payload._id ? action.payload : code
        );
      })
      .addCase(updateDiagnosisCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default diagnosisCodesSlice.reducer;
